import React, { useEffect } from "react";
import Context from "../../../../../context";

import {
  CustomLeaflet,
  CustomModal,
  CustomView,
  UserInformation,
} from "../../../../../components";
import { useQuery } from "react-query";
import api from "../../../../../api";
import values from "../../../../../values";
import { IProvinceItem } from "../../../../../types/common.interface";
import { useTranslation } from "react-i18next";

const SchoolInformation = () => {
  const { showModal, setShowModal, selectedUser } = React.useContext(
    Context.ServiceScreen
  );

  const [selectedProvince, setSelectedProvince] =
    React.useState<IProvinceItem>();

  const getAllProvince = useQuery([values.useQueryKeys.getAllProvince], () =>
    api.get.common.getAllProvince()
  );
  const getAllCity = useQuery(
    [values.useQueryKeys.getAllCity, selectedProvince],
    () => api.get.common.getAllCity({ provinceCode: selectedProvince?.Code })
  );

  useEffect(() => {
    setSelectedProvince(
      getAllProvince?.data?.result?.find(
        (item: any) => selectedUser?.province === item?._id
      )
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedUser]);

  const { t } = useTranslation();

  return (
    <section id="service-screen-show-user-information">
      <CustomModal
        onClose={() => setShowModal!("NONE")}
        minWidth={"50vw"}
        maxWidth={"85vw"}
        open={showModal === "SHOW_SCHOOL_INFORMATION"}
        overlayClose
      >
        <CustomView.Container className="scroll-content">
          <UserInformation
            avatar={selectedUser?.avatar}
            name={
              selectedUser?.firstName
                ? selectedUser?.firstName
                : selectedUser?.name
            }
            lastName={selectedUser?.lastName ? selectedUser?.lastName : ""}
            phoneNumber={
              selectedUser?.phoneNumber
                ? selectedUser?.phoneNumber
                : selectedUser?.telephone
            }
            isBlock={null}
          />
          <hr />
          <CustomView.Row className="form-column-row">
            {selectedUser?.city && (
              <CustomView.Column
                medium={5}
                small={12}
                large={4}
                className="form-values form-column"
              >
                <label className="form-label">{t("city")} :</label>
                <p>
                  {
                    getAllCity?.data?.result?.find(
                      (item: any) => selectedUser?.city === item?._id
                    )?.Name
                  }
                </p>
              </CustomView.Column>
            )}
            {selectedUser?.province && (
              <CustomView.Column
                medium={5}
                small={12}
                large={4}
                className="form-values form-column"
              >
                <label className="form-label">{t("province")} :</label>
                <p>{selectedProvince?.Name}</p>
              </CustomView.Column>
            )}
          </CustomView.Row>

          {selectedUser?.lat && (selectedUser?.lng || selectedUser?.long) && (
            <CustomView.Row className="center-row-content">
              <CustomLeaflet
                defaultLat={selectedUser.lat}
                defaultLng={selectedUser.lng}
              />
            </CustomView.Row>
          )}
        </CustomView.Container>
      </CustomModal>
    </section>
  );
};

export default SchoolInformation;
